<!--
  Wykres mieszany 30 dni: słupki = liczba zamówień (oś lewa), linia = obrót
  (oś prawa). Komponent jest celowo cienki — dane i opcje przychodzą gotowe
  z src/mixins/Dashboard.js, tutaj zostaje tylko oddanie ich do chart.js.

  Plik nie ma bloku <template> i mieć go nie może: vue-chartjs rysuje własny
  <canvas> w render() dziedziczonym przez `extends`, a szablon w SFC nadpisałby
  ten render (renderChart rzuca wtedy "Please remove the <template> tags").
-->
<script>
    import { Bar } from 'vue-chartjs'

    export default {
        name: 'OrdersChart',
        extends: Bar,
        props: {
            // Nazwa `chartOptions`, nie `options` — `options` na instancji Vue
            // oznacza co innego ($options) i łatwo o pomyłkę przy czytaniu.
            chartData: {
                type: Object,
                required: true
            },
            chartOptions: {
                type: Object,
                default: () => ({})
            }
        },
        mounted() {
            this.draw()
        },
        watch: {
            // Pulpit renderuje wykres od razu (pusty), a dane dokłada po
            // odpowiedzi API — bez obserwatora zostałby na zawsze pusty.
            // renderChart sam niszczy poprzedni wykres, więc nie zostawia
            // wiszących instancji chart.js.
            chartData() {
                this.draw()
            },
            chartOptions() {
                this.draw()
            }
        },
        methods: {
            draw() {
                this.renderChart(this.chartData, this.chartOptions)
            }
        }
    }
</script>
